import { useState, useEffect } from "react";
import { BarChart3, TrendingUp, Wallet, FileCheck } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, CartesianGrid } from "recharts";
import api from "@/lib/api";
import DashboardShell from "@/components/layout/DashboardShell";
import { adminMenu } from "@/config/menus";
import { KpiCard, PageHeader } from "@/components/KpiCard";
import { LoadingScreen, inr } from "@/components/common";

const COLORS = ["#0F172A", "#FF5A1F", "#0EA5E9", "#10B981", "#F59E0B", "#8B5CF6", "#EC4899"];

export default function AdminAnalytics() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then((r) => setD(r.data)).catch(() => {}); }, []);
  return (
    <DashboardShell menu={adminMenu} title="Business Intelligence">
      <PageHeader title="Analytics" subtitle="GMV, revenue, conversion and demand insights." />
      {!d ? <LoadingScreen /> : (
        <div className="space-y-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <KpiCard icon={Wallet} label="GMV" value={inr(d.gmv)} accent testid="an-gmv" />
            <KpiCard icon={TrendingUp} label="Commission" value={inr(d.commission)} testid="an-commission" />
            <KpiCard icon={FileCheck} label="Quote Conversion" value={`${d.quote_conversion}%`} testid="an-conversion" />
            <KpiCard icon={BarChart3} label="Avg Contract Value" value={inr(d.avg_contract_value)} testid="an-acv" />
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <KpiCard label="Total Requirements" value={d.total_requirements} testid="an-reqs" />
            <KpiCard label="Total Quotes" value={d.total_quotes} testid="an-quotes" />
          </div>

          <div className="grid lg:grid-cols-2 gap-6">
            <div className="bg-white border border-navy-200 rounded-xl p-6">
              <h3 className="font-heading font-semibold text-navy-900 mb-4">City-wise Revenue</h3>
              {d.city_revenue.length === 0 ? <p className="text-navy-500 text-sm">No data yet.</p> : (
                <ResponsiveContainer width="100%" height={280}>
                  <BarChart data={d.city_revenue}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
                    <XAxis dataKey="city" tick={{ fontSize: 12 }} /><YAxis tick={{ fontSize: 12 }} />
                    <Tooltip formatter={(v) => inr(v)} />
                    <Bar dataKey="revenue" fill="#FF5A1F" radius={[6, 6, 0, 0]} />
                  </BarChart>
                </ResponsiveContainer>
              )}
            </div>
            <div className="bg-white border border-navy-200 rounded-xl p-6">
              <h3 className="font-heading font-semibold text-navy-900 mb-4">Service Demand</h3>
              {d.service_demand.length === 0 ? <p className="text-navy-500 text-sm">No data yet.</p> : (
                <ResponsiveContainer width="100%" height={280}>
                  <PieChart>
                    <Pie data={d.service_demand} dataKey="count" nameKey="service" cx="50%" cy="50%" outerRadius={100} label={(e) => e.service}>
                      {d.service_demand.map((e, i) => <Cell key={e.service} fill={COLORS[i % COLORS.length]} />)}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
              )}
            </div>
          </div>
        </div>
      )}
    </DashboardShell>
  );
}
